const Logger = {}

'log info warn error'.split(' ').forEach(name => {
  Logger[name] = (...args) => (window.CONFIG?.logger || console)[name](...args)
})

export default Logger
